import Logo from '../Logo';

function Header() {
  return (
    <div style={{ 'backgroundColor': '#004a80' }} className='d-flex justify-content-center'>
      <Logo />
    </div>
  );
}

export default Header;
